import type { Layer, TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'

/**
 * DXF 射线（RAY）实体，由起点与单位方向向量定义的半无限直线。
 */
export default class Ray extends DatabaseObject {
  /** 所属图层 */
  layer!: Layer
  /** 线型名称，默认跟随图层 */
  lineType: string = 'ByLayer'
  /** 线宽，单位百分之毫米；-1 表示跟随图层 */
  lineWidth: number = -1
  /** 真彩色 RGB 整数，undefined 表示不写入 */
  trueColor: number | undefined

  constructor(
    public startPoint: { x: number; y: number },
    public unitVector: { x: number; y: number }
  ) {
    super(['AcDbEntity', 'AcDbRay'])
  }

  /**
   * 写入 RAY 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager) {
    manager.push(0, 'RAY')
    super.tags(manager)
    manager.push(8, this.layer.name)
    manager.push(6, this.lineType)
    manager.push(62, 256)
    manager.push(370, this.lineWidth)
    if (this.trueColor !== undefined) {
      manager.push(420, this.trueColor)
    }
    manager.point(this.startPoint.x, this.startPoint.y)
    manager.push(11, this.unitVector.x)
    manager.push(21, this.unitVector.y)
    manager.push(31, 0)
  }
}
